/* eslint-disable */

import React, {useState} from 'react'
import PageContainer  from '../../components/PageContainer/PageContainer';
import { addLocation, selectPageSize, selectPage } from './slice';
import { useAppSelector, useAppDispatch } from '../../redux/hooks';
import { Container, Title, ContentHeader, ContentBody, ActionToolbar, TopFields } from './Location.styled';
import { LocationRequest } from './types';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom';
import { BreadCrumbLink } from '../../components/PageContainer/PageContainer';

const AddLocation: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const currPageSize = useAppSelector(selectPageSize);
  const currPage = useAppSelector(selectPage);
  const[ city, setCity ] = useState('');
  const[ state, setState ] = useState('');
  const[ zipCode, setZipCode ] = useState('');
  const[ country, setCountry ] = useState('');
  const[ query, setQuery ] = useState('');

  const breadcrumbLinks: BreadCrumbLink[] = [
    {
      name: 'Locations',
      url:`/locations`
    }
  ]

  const [open, setOpen] = useState(false);

  const handleSave = () => {
    const request: LocationRequest = {
      city: city??'',
      state: state??'',
      country: country??'',
      zipCode: zipCode,
      query: query??'',
      page: currPage,
      pageSize: currPageSize
    }
    dispatch(addLocation(request))
    navigate('/locations');
  };

  return (
    <PageContainer title="Add Location" breadcrumbs={breadcrumbLinks} open={open} setOpen={setOpen}>
      <Container>
        <ContentHeader>
          <Title>Add Location</Title>
          <ActionToolbar>
            <Button variant="contained" size="small" onClick={handleSave}>
              Save
            </Button>
            <Button variant="outlined" size="small" onClick={() => navigate('/locations')}>
              Cancel
            </Button>
          </ActionToolbar>
        </ContentHeader>

        <ContentBody>
          <TopFields>
            <TextField
              id="city"
              label="City"
              variant="outlined"
              fullWidth
              size="small"
              value={city}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setCity(event.target.value);
              }}
            />
            <TextField
              id="state"
              label="State"
              variant="outlined"
              fullWidth
              size="small"
              value={state}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setState(event.target.value);
              }}
            />
            <TextField
              id="zipCode"
              label="Zip Code"
              variant="outlined"
              fullWidth
              size="small"
              value={zipCode}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setZipCode(event.target.value);
              }}
            />
            <TextField
              id="country"
              label="Country"
              variant="outlined"
              fullWidth
              size="small"
              value={country}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setCountry(event.target.value);
              }}
            />
            <TextField
              id="query"
              label="Query"
              variant="outlined"
              fullWidth
              size="small"
              value={query}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setQuery(event.target.value);
              }}
            />
          </TopFields>
        </ContentBody>
      </Container>
    </PageContainer>
  )
}

export default AddLocation
